import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Articles, CreateArticle, UpdateArticle } from "./pages";

export const ArticlesRouter = [
  <Route
    path="/articles"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Articles />
      </ProtectedRoute>
    }
  />,

  <Route path="/article">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateArticle />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateArticle />
        </ProtectedRoute>
      }
    />
  </Route>,
];
